import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Conselho de Classe',
    path: '/academico/turma/conselhodeclasse',
    name: 'conselhodeclasse',
    component: () => import('@/views/academico/turma/conselhodeclasse/ConselhoDeClasseIndex.vue'),
    meta: {
      permissions: [eTipoPermissao.CONSELHODECLASSE_MENU_300601451],
    },
    goesToMenu: true,
  },
];
